import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuardService } from "@app/core";
import { ResourceScheduleListComponent } from "@app/view/planning/resource-schedule-list/resource-schedule-list.component";

const routes: Routes = [
  {
    path: "planning",
    component: ResourceScheduleListComponent,
    data: { title: "scheduler.menu.planning" },
    canActivate: [AuthGuardService]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PlanningRoutingModule {}
